import { Col, Row, Typography } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { confirm } from 'components/atoms/modal';
import { toastService } from 'components/molecules/toast';
import { useAccount } from 'hooks/use-account';
import { useTranslation } from 'hooks/use-translation';
import { useFTUEMutation } from 'queries';
import { SettingsLabel } from '../../styles';
import { Container, Content } from '../styled';

const { Paragraph } = Typography;

export const SampleData: FC = () => {
  const { metaData } = useAccount();
  const { mutateAsync, isLoading } = useFTUEMutation();

  const remove = useTranslation('remove');
  const errorTitle = useTranslation('toolbar.info_panel_error');
  const errorMessage = useTranslation('error');
  const reloadSuccessTitle = useTranslation(
    'settings.organisation.ftue.reload.success.title',
  );
  const reloadSuccessMessage = useTranslation(
    'settings.organisation.ftue.reload.success.message',
  );
  const removeSuccessTitle = useTranslation(
    'settings.organisation.ftue.remove.success.title',
  );
  const removeSuccessMessage = useTranslation(
    'settings.organisation.ftue.remove.success.message',
  );

  const removeConfirmTitle = useTranslation(
    'settings.organisation.ftue.remove.confirm.title',
  );
  const removeConfirmMessage = useTranslation(
    'settings.organisation.ftue.remove.confirm.content',
  );
  const onError = () =>
    toastService({
      title: errorTitle,
      message: errorMessage,
    }).error();

  const removeSampleData = async () => {
    confirm({
      title: removeConfirmTitle,
      content: removeConfirmMessage,
      okText: remove,
      onOk: async () =>
        mutateAsync(
          { enabled: false },
          {
            onSuccess: async () => {
              toastService({
                title: removeSuccessTitle,
                message: removeSuccessMessage,
              }).success();
            },
            onError,
          },
        ),
    });

    return true;
  };

  const reloadSampleData = async () => {
    await mutateAsync(
      { enabled: true },
      {
        onSuccess: async () => {
          toastService({
            title: reloadSuccessTitle,
            message: reloadSuccessMessage,
          }).success();
        },
        onError,
      },
    );
  };

  return (
    <Row>
      <Col xxl={12}>
        <Container>
          <SettingsLabel>
            <FormattedMessage id="sample_data" />
          </SettingsLabel>
          <Content>
            <Paragraph>
              <FormattedMessage id="settings.organisation.ftue.description" />
            </Paragraph>

            {metaData?.ftue ? (
              <Button onClick={removeSampleData} loading={isLoading}>
                <FormattedMessage id="settings.organisation.ftue.remove.button" />
              </Button>
            ) : (
              <Button onClick={reloadSampleData} loading={isLoading}>
                <FormattedMessage id="settings.organisation.ftue.reload.button" />
              </Button>
            )}
          </Content>
        </Container>
      </Col>
    </Row>
  );
};
